// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  servicePath: "http://mybiz6-lite.mybiz.net/AppService/AppService.svc/",
  loginBackdrop: "../../assets/images/business-1-dark.jpg",
  portalTitle: "MyBiz eProcurement Portal (Dev)",
  portalTab: "MyBiz Lite Dev",
  allowRegistration: true,
  primaryColor: '#007BC4',
  secondaryColor: '#EDF7FD',
  accentColor: '#4A98DC'
}
//servicePath: "https://mybizlitedev.mybiz.net/AppService/AppService.svc/"
//stag
//servicePath: "http://mybizlite-stag.mybiz.net/AppService/AppService.svc/"

//dev
//servicePath: "http://mybiz6-appservice.mybiz.net/AppService.svc/"

//local
//servicePath: "http://localhost:33142/AppService.svc/"
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
